import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import commonEN from "../locales/en/common.json";
import bookingEN from "../locales/en/booking.json";
import errorsEN from "../locales/en/errors.json";

import commonESMX from "../locales/es-MX/common.json";
import bookingESMX from "../locales/es-MX/booking.json";
import errorsESMX from "../locales/es-MX/errors.json";

import commonFRCA from "../locales/fr-CA/common.json";
import bookingFRCA from "../locales/fr-CA/booking.json";
import errorsFRCA from "../locales/fr-CA/errors.json";

// Translation resources
const resources = {
  en: {
    common: commonEN,
    booking: bookingEN,
    errors: errorsEN
  },
  "es-MX": {
    common: commonESMX,
    booking: bookingESMX,
    errors: errorsESMX
  },
  "fr-CA": {
    common: commonFRCA,
    booking: bookingFRCA,
    errors: errorsFRCA
  },
  // Add base language mappings to prevent spam
  es: {
    common: commonESMX,
    booking: bookingESMX,
    errors: errorsESMX
  },
  fr: {
    common: commonFRCA,
    booking: bookingFRCA,
    errors: errorsFRCA
  }
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,

    // Default language
    fallbackLng: "en",

    // Default namespace
    defaultNS: "common",

    // Language detection options
    detection: {
      // Look for language in localStorage, navigator, htmlTag, path, subdomain
      order: ["localStorage", "navigator", "htmlTag", "path", "subdomain"],

      // Cache user language
      caches: ["localStorage"]
    },

    // Supported languages (include base codes to prevent rejection spam)
    supportedLngs: ["en", "es-MX", "fr-CA", "es", "fr"],

    // Interpolation options
    interpolation: {
      escapeValue: false // React already does escaping
    },

    // React options
    react: {
      useSuspense: false // Avoid suspense for SSR compatibility
    },

    // Debug mode (only in development)
    debug: import.meta.env.DEV
  });

export default i18n;
